export default __webpack_public_path__ + "images/8E.874e801.png";